import { Controller } from "@hotwired/stimulus"

// The "check your email" modal shown after subscribing. Counts down the
// resend throttle (60s server-side) before enabling the resend button, and
// closes on X or backdrop click, revealing the page (and its email form)
// underneath.
export default class extends Controller {
  static targets = ["resend", "countdown"]
  static values = { seconds: { type: Number, default: 60 } }

  connect() {
    this.remaining = this.secondsValue
    this.timer = setInterval(() => this.tick(), 1000)
    this.render()
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    this.remaining -= 1
    if (this.remaining <= 0) {
      clearInterval(this.timer)
      if (this.hasResendTarget) {
        this.resendTarget.disabled = false
      }
    }
    this.render()
  }

  render() {
    if (!this.hasCountdownTarget) return
    this.countdownTarget.textContent =
      this.remaining > 0 ? `Didn't get it? Check spam — you can resend in ${this.remaining}s.` : "Didn't get it? Check spam, or resend it now."
  }

  close() {
    this.element.remove()
  }

  backdrop(event) {
    if (event.target === event.currentTarget) this.close()
  }
}
